import { render, staticRenderFns } from "./EstimatesOldPanelsActions.vue?vue&type=template&id=273e0d60&"
import script from "./EstimatesOldPanelsActions.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldPanelsActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports